import React, { useState } from "react";
import { Button, CardBody, Col, FormGroup, Label, Row } from "reactstrap";
import { Controller } from "react-hook-form";
import Typeahead from "../../../CommonElements/TypeAhead/index";
import {
  DefaultDueDays,
  Invoiceprefix,
  Invoicesiffix,
  Next,
  QuantityName,
} from "../../../Constant";
import { duedateOptions } from "../../Company/Duedate";

const quantityOptions = [{ value: "quantitiy", label: "Quantitiy" }];

const InvoiceForm = ({ register, control }) => {
  const [icon, setIcon] = useState("");

  const handleIconChange = (event) => {
    const selectedFile = event.target.files[0];
    setIcon(selectedFile);
  };

  return (
    <CardBody>
      <Row className="g-3">
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="prefix">{Invoiceprefix}</Label>
            <input
              className="form-control"
              type="text"
              name="inv-prefix"
              {...register("invprefix")}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="suffix">{Invoicesiffix}</Label>
            <input
              className="form-control"
              type="number"
              min={1}
              defaultValue={1}
              name="inv-suffix"
              {...register("invsuffix", { value: 1 })}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row className="g-3">
        <Col md="6">
          <FormGroup className="mb-3">
            <Label htmlFor="quantityname">{QuantityName}</Label>
            <Controller
              name="quantityname"
              control={control}
              render={({ field }) => (
                <Typeahead
                  id="quantityname"
                  options={quantityOptions}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                  value={field.value}
                />
              )}
            />
          </FormGroup>
        </Col>
        <Col md="6">
          <Label htmlFor="duedate">{DefaultDueDays}</Label>
          <Controller
            name="duedate"
            control={control}
            defaultValue={duedateOptions[0]}
            render={({ field }) => (
              <Typeahead
                options={duedateOptions}
                onChange={(value) => {
                  field.onChange(value);
                }}
                value={field.value}
              />
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <Label className="form-label">Icon</Label>
          <Controller
            name="icon"
            control={control}
            render={({ field }) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Col md="8">
                  <input
                    {...register("icon")}
                    className="form-control fileInputStyle"
                    type="file"
                    onChange={handleIconChange}
                    accept=".png, .jpg, .jpeg"
                  />
                </Col>
                <Col md="4">
                  <span className="imagestyle">
                    {icon &&
                    <img
                      src={URL.createObjectURL(icon)}
                      alt="icon"
                      width="40px"
                      height="40px"
                    />
                     } 
                  </span>
                </Col>
              </div>
            )}
          />
        </Col>
      </Row>
      <div className="text-end">
        <Button className="tab-button">{Next}</Button>
        {/* <Button className="tab-button" onClick={nextTab}>{Next}</Button> */}
      </div>
    </CardBody>
  );
};

export default InvoiceForm;
